import { InfoAlert } from "./styles";
import closeIcon from "./imgs/close-icon.svg";
//import headerKeyfob from "./imgs/your-keyfob-banner.webp";

const YourKeyfob = ({ onClose }) => {
  return (
    <InfoAlert>
      <div className="inner-container">
        <div className="img-container">
          {/* <img src={headerKeyfob} alt="header" /> */}
          <h2>{"Your Keyfob"}</h2>
        </div>
        <div className="close-button" onClick={onClose}>
          <img src={closeIcon} alt="close" />
        </div>
        <div className="scroll-view">
          <div className="section">
            <p>{"Your keyfob is more than just an accessory! "}</p>
          </div>

          <div className="section">
            <p className="bold">{"Find out more about your keyfob"}</p>
            <p>{"Click here to find out more about your keyfob."}</p>
            <div className="group btn-group group-reversed">
              <div className="button">
                <p>{"Find out more"}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </InfoAlert>
  );
};

export default YourKeyfob;
